// tslint:disable-next-line:ordered-imports
import { ENVIRONMENT } from '@arnold/core';
import 'bootstrap/dist/css/bootstrap.css';
import 'core-js/stable';
import 'font-awesome/css/font-awesome.min.css';
import './assets/scss/paper-dashboard.scss';
// tslint:disable-next-line:ordered-imports
import { applyBrandToDocument, getFrontendConfigValue } from '@arnold/common';
import { init } from '@sentry/browser';
import { contains } from 'ramda';
import { createRoot } from 'react-dom/client';
import App from './App';
import './assets/scss/main.scss';
import './index.css';
import './translations/i18n';

const appEnvironment = getFrontendConfigValue('ENVIRONMENT');

(window as any).dataLayer?.push({ event: 'arnoldConfigReady', 'arnold.environment': appEnvironment });

const isSentryEnabled = contains(appEnvironment, [ENVIRONMENT.PROD]);

if (isSentryEnabled) {
  init({
    dsn: getFrontendConfigValue('ADMIN_SENTRY_DSN'),
    release: process.env.REACT_APP_DOCKER_VERSION,
    environment: appEnvironment,
  });
}
applyBrandToDocument();
const container = document.getElementById('root');
const root = createRoot(container!);
root.render(<App />);
